import React, { useState } from 'react';
import Tabs from 'components/common/tabsTable/TabsTable';
import {
  DEVICE_CONFIGURATION_TABS,
  DEVICE_CONFIGURATION_TABS_VALUES,
} from 'constants/store/deviceConfigurationTabs';
import type { StoreDefaultRelease } from 'types/store';
import styles from './StoreDeviceConfiguration.module.scss';
import './StoreDeviceConfiguration.scss';
import { StoreDefaultReleases } from './defaultReleases/StoreDefaultReleases';
import { StoreEnvVariables } from './envVariables/StoreEnvVariables';

interface StoreDeviceConfigurationProps {
  envVariables?: Record<string, string>;
  defaultReleases?: StoreDefaultRelease[];
  storeId: number;
  onUpdateSuccess?: () => void;
}

export const StoreDeviceConfiguration: React.FC<StoreDeviceConfigurationProps> = ({
  envVariables,
  defaultReleases,
  storeId,
  onUpdateSuccess,
}) => {
  const [selectedTab, setSelectedTab] = useState<DEVICE_CONFIGURATION_TABS_VALUES>(
    DEVICE_CONFIGURATION_TABS_VALUES.ENV_VARIABLES,
  );

  return (
    <div className="store-device-configuration">
      <div className={styles.tabsContainer}>
        <div className={styles.tabsSidebar}>
          <Tabs
            tabsData={DEVICE_CONFIGURATION_TABS}
            tabValueSelected={selectedTab}
            handleTabChange={(
              _: React.SyntheticEvent,
              newValue: DEVICE_CONFIGURATION_TABS_VALUES,
            ) => {
              setSelectedTab(newValue);
            }}
            orientation="vertical"
          />
        </div>

        <div className={styles.tabPanel}>
          {selectedTab === DEVICE_CONFIGURATION_TABS_VALUES.ENV_VARIABLES && (
            <StoreEnvVariables
              envVariables={envVariables}
              storeId={storeId}
              onUpdateSuccess={onUpdateSuccess}
            />
          )}

          {selectedTab === DEVICE_CONFIGURATION_TABS_VALUES.DEFAULT_RELEASES && (
            <StoreDefaultReleases
              defaultReleases={defaultReleases}
              storeId={storeId}
              onUpdateSuccess={onUpdateSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};
